export default __webpack_public_path__ + "static/media/hippo_HAPPY.973db2eb.png";